enum GeneralLedgerAccountType {
  General = 'General',
  ReserveCapital = 'ReserveCapital',
  FixedWorkCapital = 'FixedWorkCapital',
  WorkCapital = 'WorkCapital',
}

export default GeneralLedgerAccountType;
